import noAuthorizedInterceptor, { setAuth0Logout as setAuth0LogoutResponse } from './noAuthorized';
import tokenValidatorInterceptor, { setAuth0Logout as setAuth0LogoutRequest } from './tokenValidator';

export const setAuth0Logout = (logoutFn) => {
  setAuth0LogoutResponse(logoutFn);
  setAuth0LogoutRequest(logoutFn);
};

export { tokenValidatorInterceptor };
export default noAuthorizedInterceptor;